/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useContext, useEffect, useRef, useMemo } from "react";
import {
  Box,
  Button,
  FormControl,
  InputLabel,
  ListItemText,
  MenuItem,
  OutlinedInput,
  Select,
  TextField,
  Typography,
  Stack,
  Tabs,
  Tab,
  Paper,
  Tooltip,
  IconButton,
  Checkbox,
  Chip,
  InputAdornment,
  LinearProgress,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Slide,
  Alert,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import DeleteIcon from "@mui/icons-material/Delete";
import PlayCircleOutlineIcon from "@mui/icons-material/PlayCircleOutline";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import MonetizationOnOutlinedIcon from "@mui/icons-material/MonetizationOnOutlined";
import PhotoLibraryOutlinedIcon from "@mui/icons-material/PhotoLibraryOutlined";
import StorefrontOutlinedIcon from "@mui/icons-material/StorefrontOutlined";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import CloudUploadOutlinedIcon from "@mui/icons-material/CloudUploadOutlined";

import CustomButton from "../../common/Button/CustomButton";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import AddProductImage from "../../../assets/images/placeholder/add-product.jpg";

import {
  ref,
  uploadBytesResumable,
  getDownloadURL,
  deleteObject,
} from "firebase/storage";
import { storage } from "../../../firebase";
import "./styles.scss";

import FileUpload from "../../common/FileUpload";
import CompressAPI from "../../../api/compressImage/CompressAPI";
import AddProductContext from "../../../context/addProduct/AddProductContext";
import AllCategoriesContext from "../../../context/allCategories/AllCategoriesContext";
import AllPropertiesContext from "../../../context/allProperties/AllPropertiesContext";
import ProductsAPI from "../../../api/firebase/ProductsAPI";
import PropertiesAPI from "../../../api/firebase/PropertiesAPI";
import { defaultStarterProperties } from "../../../pages/admin/properties";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const AddProduct = ({ hideModal, handleSetProduct, action, onDeleteProduct }) => {
  const [activeTab, setActiveTab] = useState(0);
  const [errorMsg, setErrorMsg] = useState("");
  const [openErrorDialog, setOpenErrorDialog] = useState(false);
  const [isUploading, setIsUploading] = useState(false);
  const [isAddingRatings, setIsAddingRatings] = useState(false);

  const productContext = useContext(AddProductContext);
  const allCategoriesContext = useContext(AllCategoriesContext);
  const allCategoriesArr = Array.isArray(allCategoriesContext.state)
    ? allCategoriesContext.state
    : [];

  const [selSubCategories, setSelSubCategories] = useState([]);
  const [subCategories, setSubCategories] = useState([]);

  const allPropertiesContext = useContext(AllPropertiesContext);
  const [availableProperties, setAvailableProperties] = useState(
    Array.isArray(allPropertiesContext?.state) && allPropertiesContext.state.length > 0
      ? allPropertiesContext.state
      : defaultStarterProperties
  );

  useEffect(() => {
    let isMounted = true;
    const fetchProps = async () => {
      try {
        const propApi = new PropertiesAPI();
        const res = await propApi.getProperties();
        if (res && res.success && Array.isArray(res.data) && res.data.length > 0) {
          if (isMounted) {
            setAvailableProperties(res.data);
            if (allPropertiesContext?.setState) {
              allPropertiesContext.setState(res.data);
            }
          }
        }
      } catch (e) {
        console.error("Error loading properties in AddProduct:", e);
      }
    };
    if (!allPropertiesContext?.state || allPropertiesContext.state.length === 0) {
      fetchProps();
    }
    return () => {
      isMounted = false;
    };
  }, [allPropertiesContext]);

  const productsAPI = new ProductsAPI();

  const parentCategories = allCategoriesArr.filter((cat) => {
    return cat.parentCategory && (cat.parentCategory.id === "None" || cat.parentCategory.id === "NONE");
  });

  const initProImages = productContext.state.images || [];
  const [imageData, setImageData] = useState(initProImages);
  const [progress, setProgress] = useState(0);
  const [videoProgress, setVideoProgress] = useState(0);
  const [videoData, setVideoData] = useState(
    productContext.state.video ? productContext.state.video : null
  );
  const [openVideoDialog, setOpenVideoDialog] = useState(false);

  useEffect(() => {
    const _selSubCategories = productContext.state.categories || [];
    setSelSubCategories(_selSubCategories);
    const selCatId = productContext.state.parentCategory?.id;
    if (selCatId) {
      const _subCategories = allCategoriesArr.filter(
        (e) => e.parentCategory?.id === selCatId
      );
      setSubCategories(_subCategories);
    }
  }, []);

  useEffect(() => {
    setImageData(productContext.state.images || []);
  }, [productContext.state.images]);

  useEffect(() => {
    setVideoData(productContext.state.video || null);
  }, [productContext.state.video]);

  const handleChangeCategory = (event) => {
    setSelSubCategories([]);
    const selCatId = event.target.value;
    if (selCatId === "NONE") {
      productContext.setState({
        ...productContext.state,
        parentCategory: {
          id: "NONE",
          name: "None",
        },
        categories: [],
      });
      setSubCategories([]);
      return;
    }
    const categoryDetail = parentCategories.find((e) => e.id === selCatId);
    const subCategoriesArr = allCategoriesArr.filter(
      (e) => e.parentCategory?.id === selCatId
    );
    setSubCategories(subCategoriesArr);
    productContext.setState({
      ...productContext.state,
      parentCategory: {
        id: categoryDetail?.id || selCatId,
        name: categoryDetail?.name || "",
        images: categoryDetail?.images || [],
        showInNavbar: categoryDetail?.showInNavbar || false,
      },
      categories: [],
    });
  };

  const handleChangeSubcategory = (event) => {
    const {
      target: { value },
    } = event;
    const tempSubcategories =
      typeof value === "string" ? value.split(",") : value;

    setSelSubCategories(tempSubcategories);
    productContext.setState({
      ...productContext.state,
      categories: tempSubcategories,
    });
  };

  function handleFormData(formData) {
    productContext.setState({ ...productContext.state, ...formData });
  }

  const selectedPropertyIds = useMemo(() => {
    const raw = productContext.state?.properties;
    if (!Array.isArray(raw)) return [];
    return raw.map((item) => (typeof item === "object" && item !== null ? item.id : item));
  }, [productContext.state?.properties]);

  const handleChangeProperties = (event) => {
    const {
      target: { value },
    } = event;
    const newPropertyIds = typeof value === "string" ? value.split(",") : value;
    handleFormData({ properties: newPropertyIds });
  };

  const handleTogglePropertyChip = (propId) => {
    const exists = selectedPropertyIds.includes(propId);
    const updated = exists
      ? selectedPropertyIds.filter((id) => id !== propId)
      : [...selectedPropertyIds, propId];
    handleFormData({ properties: updated });
  };

  const handleAddProductClick = () => {
    setErrorMsg("");

    if (
      !productContext.state.parentCategory ||
      productContext.state.parentCategory.id === "NONE" ||
      !productContext.state.parentCategory.id
    ) {
      setActiveTab(0);
      setErrorMsg("Please select a Parent Category.");
      return;
    }
    if (!productContext.state.title || productContext.state.title.trim().length < 5) {
      setActiveTab(0);
      setErrorMsg("Product title must be at least 5 characters.");
      return;
    }
    if (Number(productContext.state.listPrice) <= 0) {
      setActiveTab(1);
      setErrorMsg("List Price must be greater than 0.");
      return;
    }
    if (Number(productContext.state.maxPrice) <= 0) {
      setActiveTab(1);
      setErrorMsg("MRP (Max Price) must be greater than 0.");
      return;
    }
    if (
      Number(productContext.state.listPrice) >
      Number(productContext.state.maxPrice)
    ) {
      setActiveTab(1);
      setErrorMsg("List Price (Selling Price) cannot exceed MRP.");
      return;
    }
    if (
      productContext.state.unitsInStock === "" ||
      isNaN(Number(productContext.state.unitsInStock)) ||
      Number(productContext.state.unitsInStock) < 0
    ) {
      setActiveTab(1);
      setErrorMsg("Units in stock must be 0 or greater.");
      return;
    }
    if (
      productContext.state.netQuantity === "" ||
      Number(productContext.state.netQuantity) <= 0
    ) {
      setActiveTab(1);
      setErrorMsg("Net Quantity must be greater than 0.");
      return;
    }
    if (!productContext.state.unitType) {
      setActiveTab(1);
      setErrorMsg("Please select a unit type.");
      return;
    }
    if (!productContext.state.images || productContext.state.images.length === 0) {
      setActiveTab(2);
      setErrorMsg("Please provide at least one product image.");
      return;
    }
    if (
      !productContext.state.description ||
      productContext.state.description.replace(/<[^>]*>/g, "").trim().length < 10
    ) {
      setActiveTab(4);
      setErrorMsg("Please provide a product description (at least 10 characters).");
      return;
    }

    handleSetProduct(action, productContext.state.id);
  };

  function handleImageChange(e) {
    setProgress(0);
    setIsUploading(true);
    const upImage = e.target.files && e.target.files[0];
    if (upImage) {
      const compressProps = {
        size: 2,
        quality: 1,
        maxWidth: 900,
        maxHeight: 900,
        resize: true,
        rotate: true,
      };
      const imgCompressor = new CompressAPI();
      const req = imgCompressor.compressImage(upImage, compressProps);
      req
        .then((resData) => {
          if (!resData.success) {
            setIsUploading(false);
            return;
          }
          const imgBlob = resData.data;
          const fileName = "IMG_" + Date.now() + "_" + (imgBlob.alt || "upload");
          const base64str = imgBlob.data;
          const imgExt = imgBlob.ext;

          setImageData((prevState) => {
            if (prevState) {
              return [...prevState, { ...imgBlob, name: fileName }];
            } else {
              return [{ ...imgBlob, name: fileName }];
            }
          });

          const reqData = imgCompressor.base64ToImage(base64str, imgExt);
          if (!reqData.success) {
            setIsUploading(false);
            return;
          }
          const file = reqData.data;
          handleFileUpload({
            path: "images/products/",
            file,
            fileName,
          });
        })
        .catch((ex) => {
          setIsUploading(false);
          console.log("CompressImage Error:", ex);
        });
    } else {
      setIsUploading(false);
    }
  }

  const handleFileUpload = ({ path, file, fileName }) => {
    fileName = fileName.replace(/[()]/g, "");
    const storageRef = ref(storage, `${path}/${fileName}`);
    const uploadTask = uploadBytesResumable(storageRef, file);

    uploadTask.on(
      "state_changed",
      (snapshot) => {
        const prog = Math.round(
          (snapshot.bytesTransferred / snapshot.totalBytes) * 100
        );
        setProgress(prog);
      },
      (error) => {
        setIsUploading(false);
        setErrorMsg("Image upload failed: " + error.message);
      },
      () => {
        getDownloadURL(uploadTask.snapshot.ref)
          .then((downloadURL) => {
            setIsUploading(false);
            const newImages = [
              ...(productContext.state.images || []),
              { name: fileName, url: downloadURL },
            ];
            productContext.setState({
              ...productContext.state,
              images: newImages,
            });
            const pro_id = productContext.state.id;
            if (pro_id && pro_id !== "") {
              productsAPI.getProductById(pro_id).then((res) => {
                if (res.success) {
                  const dataToSend = {
                    id: pro_id,
                    payload: { images: newImages },
                  };
                  productsAPI.setProduct(dataToSend, false);
                }
              });
            }
          })
          .catch((ex) => {
            setIsUploading(false);
            setErrorMsg("Error obtaining image URL.");
          });
      }
    );
  };

  const handleDeleteFile = (index, fileName) => {
    const tempImageData = [...imageData];
    tempImageData.splice(index, 1);
    setImageData(tempImageData);

    const fileRef = ref(storage, `images/products/${fileName}`);
    deleteObject(fileRef)
      .then(() => {
        const updatedURLs = (productContext.state.images || []).filter(
          (state) => state.name !== fileName
        );
        productContext.setState({
          ...productContext.state,
          images: updatedURLs,
        });
        const pro_id = productContext.state.id;
        if (pro_id && pro_id !== "") {
          productsAPI.getProductById(pro_id).then((res) => {
            if (res.success) {
              const dataToSend = {
                id: pro_id,
                payload: { images: updatedURLs },
              };
              productsAPI.setProduct(dataToSend, false);
            }
          });
        }
      })
      .catch((err) => {
        console.log("Error while deleting image: ", err);
        const updatedURLs = (productContext.state.images || []).filter(
          (state) => state.name !== fileName
        );
        productContext.setState({
          ...productContext.state,
          images: updatedURLs,
        });
      });
  };

  function handleVideoChange(e) {
    setVideoProgress(0);
    setIsUploading(true);
    const upVideo = e.target.files && e.target.files[0];
    if (!upVideo) {
      setIsUploading(false);
      return;
    }
    if (!upVideo.type.startsWith("video/")) {
      setIsUploading(false);
      setErrorMsg("Please select a valid video file.");
      return;
    }
    const maxBytes = 20 * 1024 * 1024;
    if (upVideo.size > maxBytes) {
      setIsUploading(false);
      setErrorMsg("Video file must be 20MB or less.");
      return;
    }
    const safeName = upVideo.name.replace(/[()]/g, "");
    const fileName = "VID_" + Date.now() + "_" + safeName;
    handleVideoUpload({ path: "videos/products", file: upVideo, fileName });
  }

  const handleVideoUpload = ({ path, file, fileName }) => {
    const storageRef = ref(storage, `${path}/${fileName}`);
    const uploadTask = uploadBytesResumable(storageRef, file);

    uploadTask.on(
      "state_changed",
      (snapshot) => {
        const prog = Math.round(
          (snapshot.bytesTransferred / snapshot.totalBytes) * 100
        );
        setVideoProgress(prog);
      },
      (error) => {
        setIsUploading(false);
        setErrorMsg("Video upload failed: " + error.message);
      },
      () => {
        getDownloadURL(uploadTask.snapshot.ref)
          .then((downloadURL) => {
            setIsUploading(false);
            const newVideo = { name: fileName, url: downloadURL };
            setVideoData(newVideo);
            productContext.setState({
              ...productContext.state,
              video: newVideo,
            });
            const pro_id = productContext.state.id;
            if (pro_id && pro_id !== "") {
              productsAPI.getProductById(pro_id).then((res) => {
                if (res.success) {
                  const dataToSend = {
                    id: pro_id,
                    payload: { video: newVideo },
                  };
                  productsAPI.setProduct(dataToSend, false);
                }
              });
            }
          })
          .catch((ex) => {
            setIsUploading(false);
            setErrorMsg("Error while fetching video url: " + ex);
          });
      }
    );
  };

  const handleDeleteVideo = (fileName) => {
    const fileRef = ref(storage, `videos/products/${fileName}`);
    deleteObject(fileRef)
      .then(() => {
        setVideoData(null);
        productContext.setState({
          ...productContext.state,
          video: null,
        });
        const pro_id = productContext.state.id;
        if (pro_id && pro_id !== "") {
          const dataToSend = {
            id: pro_id,
            payload: { video: null },
          };
          productsAPI.setProduct(dataToSend, false);
        }
      })
      .catch(() => {
        setVideoData(null);
        productContext.setState({
          ...productContext.state,
          video: null,
        });
      });
  };

  const addRatings = () => {
    if (!window.confirm("Add simulated customer ratings to this product?")) {
      return;
    }
    setIsAddingRatings(true);
    const min5 = 60, max5 = 100;
    const min4 = 5, max4 = 8;
    const min3 = 2, max3 = 5;
    const min2 = 1, max2 = 3;
    const min1 = 0, max1 = 2;

    const total5 = Math.floor(Math.random() * (max5 - min5)) + min5;
    const total4 = Math.floor(Math.random() * (max4 - min4)) + min4;
    const total3 = Math.floor(Math.random() * (max3 - min3)) + min3;
    const total2 = Math.floor(Math.random() * (max2 - min2)) + min2;
    const total1 = Math.floor(Math.random() * (max1 - min1)) + min1;

    let ratingArr = [];
    for (let i = 0; i < total5; i++) ratingArr.push(5);
    for (let i = 0; i < total4; i++) ratingArr.push(4);
    for (let i = 0; i < total3; i++) ratingArr.push(3);
    for (let i = 0; i < total2; i++) ratingArr.push(2);
    for (let i = 0; i < total1; i++) ratingArr.push(1);

    const pro_id = productContext.state.id;
    if (pro_id) {
      productsAPI
        .setProductRatings(pro_id, ratingArr)
        .then(() => {
          setIsAddingRatings(false);
          alert("Ratings added successfully!");
        })
        .catch((err) => {
          setIsAddingRatings(false);
          console.error("Error setting ratings:", err);
          alert("Failed to add ratings.");
        });
    } else {
      setIsAddingRatings(false);
    }
  };

  // Live discount calculation
  const mrp = Number(productContext.state.maxPrice) || 0;
  const listPrice = Number(productContext.state.listPrice) || 0;
  const discountAmount = mrp > listPrice ? mrp - listPrice : 0;
  const discountPercent = mrp > 0 && mrp >= listPrice ? Math.round((discountAmount / mrp) * 100) : 0;

  return (
    <Box className="admin-product-modal-container">
      {/* Header */}
      <Box className="modal-header">
        <Stack direction="row" spacing={{ xs: 1.25, sm: 1.5 }} alignItems="center" sx={{ minWidth: 0, flex: 1 }}>
          <Box
            sx={{
              width: { xs: 34, sm: 40 },
              height: { xs: 34, sm: 40 },
              borderRadius: "10px",
              bgcolor: "primary.main",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              color: "#ffffff",
              flexShrink: 0,
            }}
          >
            {action === "ADD" ? <CloudUploadOutlinedIcon fontSize="small" /> : <CheckCircleOutlineIcon fontSize="small" />}
          </Box>
          <Box sx={{ minWidth: 0, pr: 1 }}>
            <Typography
              variant="h6"
              sx={{
                fontWeight: 800,
                lineHeight: 1.2,
                color: "#1e293b",
                fontSize: { xs: "0.95rem", sm: "1.25rem" },
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            >
              {action === "ADD" ? "Create New Product" : "Edit Product Catalog"}
            </Typography>
            <Typography
              variant="caption"
              sx={{
                color: "#64748b",
                display: "block",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            >
              {action === "ADD"
                ? "Fill in details to add a new item"
                : `SKU: ${productContext.state.id || "N/A"}`}
            </Typography>
          </Box>
        </Stack>

        <Stack direction="row" spacing={1} alignItems="center" sx={{ flexShrink: 0 }}>
          {productContext.state.id && (
            <Chip
              label={`SKU: ${productContext.state.id}`}
              size="small"
              sx={{ fontWeight: 700, bgcolor: "#f1f5f9", color: "#334155", display: { xs: "none", sm: "inline-flex" } }}
            />
          )}
          <IconButton onClick={hideModal} size="small" sx={{ color: "#64748b", "&:hover": { bgcolor: "#f1f5f9" } }}>
            <CloseIcon />
          </IconButton>
        </Stack>
      </Box>

      {/* Tabs */}
      <Box className="modal-tabs-bar">
        <Tabs
          value={activeTab}
          onChange={(e, val) => setActiveTab(val)}
          variant="scrollable"
          scrollButtons="auto"
          allowScrollButtonsMobile
        >
          <Tab icon={<InfoOutlinedIcon fontSize="small" />} iconPosition="start" label="General Info" />
          <Tab icon={<MonetizationOnOutlinedIcon fontSize="small" />} iconPosition="start" label="Pricing & Inventory" />
          <Tab
            icon={<PhotoLibraryOutlinedIcon fontSize="small" />}
            iconPosition="start"
            label={`Media (${(productContext.state.images || []).length})`}
          />
          <Tab icon={<StorefrontOutlinedIcon fontSize="small" />} iconPosition="start" label="Marketplaces" />
          <Tab icon={<DescriptionOutlinedIcon fontSize="small" />} iconPosition="start" label="Description" />
        </Tabs>
      </Box>

      {/* Upload Progress Bar */}
      {isUploading && (
        <Box sx={{ width: "100%" }}>
          <LinearProgress variant="determinate" value={progress || videoProgress || 20} sx={{ height: 4 }} />
        </Box>
      )}

      {/* Scrollable Content */}
      <Box className="modal-content-scroll">
        {errorMsg && (
          <Alert severity="error" sx={{ mb: 2.5, borderRadius: 2 }} onClose={() => setErrorMsg("")}>
            {errorMsg}
          </Alert>
        )}

        {/* TAB 0: General Info */}
        {activeTab === 0 && (
          <Stack spacing={2.5}>
            <Paper elevation={0} sx={{ p: { xs: 1.75, sm: 2.5 }, border: "1px solid #e2e8f0", borderRadius: 3 }}>
              <Typography variant="subtitle2" sx={{ fontWeight: 800, color: "#334155", mb: 2 }}>
                Category Assignment
              </Typography>
              <Stack direction={{ xs: "column", sm: "row" }} spacing={2}>
                <FormControl fullWidth size="small">
                  <InputLabel id="parentCategory-label">Parent Category *</InputLabel>
                  <Select
                    labelId="parentCategory-label"
                    value={productContext.state.parentCategory?.id || "NONE"}
                    label="Parent Category *"
                    onChange={handleChangeCategory}
                  >
                    <MenuItem value="NONE">
                      <em>Select Parent Category</em>
                    </MenuItem>
                    {parentCategories.map((cat) => (
                      <MenuItem key={cat.id} value={cat.id}>
                        {cat.name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>

                {subCategories.length > 0 && (
                  <FormControl fullWidth size="small">
                    <InputLabel id="subcategories-label">Subcategories</InputLabel>
                    <Select
                      labelId="subcategories-label"
                      multiple
                      value={selSubCategories}
                      onChange={handleChangeSubcategory}
                      input={<OutlinedInput label="Subcategories" />}
                      renderValue={(selected) => (
                        <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                          {selected.map((val) => (
                            <Chip key={val} label={val.replace(/_/g, " ")} size="small" />
                          ))}
                        </Box>
                      )}
                      MenuProps={MenuProps}
                    >
                      {subCategories.map((cat) => (
                        <MenuItem key={cat.id} value={cat.id}>
                          <Checkbox checked={selSubCategories.indexOf(cat.id) > -1} size="small" />
                          <ListItemText primary={cat.name} />
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                )}
              </Stack>
            </Paper>

            <Paper elevation={0} sx={{ p: { xs: 1.75, sm: 2.5 }, border: "1px solid #e2e8f0", borderRadius: 3 }}>
              <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 1, flexWrap: "wrap", gap: 1 }}>
                <Box>
                  <Typography variant="subtitle2" sx={{ fontWeight: 800, color: "#334155" }}>
                    Properties & Health Benefits
                  </Typography>
                  <Typography variant="caption" sx={{ color: "#64748b" }}>
                    A product can belong to multiple properties (e.g. Hair Care, Body Detox, Pain & Massage)
                  </Typography>
                </Box>
                {selectedPropertyIds.length > 0 && (
                  <Chip
                    label={`${selectedPropertyIds.length} Selected`}
                    size="small"
                    sx={{ bgcolor: "#075e54", color: "#fff", fontWeight: 700, height: 22 }}
                  />
                )}
              </Box>

              <FormControl fullWidth size="small" sx={{ mt: 1 }}>
                <InputLabel id="product-properties-label">Associated Properties</InputLabel>
                <Select
                  labelId="product-properties-label"
                  id="product-properties-select"
                  multiple
                  value={selectedPropertyIds}
                  onChange={handleChangeProperties}
                  input={<OutlinedInput label="Associated Properties" />}
                  renderValue={(selected) => (
                    <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                      {selected.map((val) => {
                        const propObj = availableProperties.find((p) => p.id === val);
                        return (
                          <Chip
                            key={val}
                            label={propObj ? propObj.label : val}
                            size="small"
                            sx={{
                              bgcolor: "#eef7f4",
                              color: "#075e54",
                              fontWeight: 700,
                              borderColor: "#a7f3d0",
                            }}
                          />
                        );
                      })}
                    </Box>
                  )}
                  MenuProps={MenuProps}
                >
                  {availableProperties.map((prop) => {
                    const isChecked = selectedPropertyIds.indexOf(prop.id) > -1;
                    return (
                      <MenuItem key={prop.id} value={prop.id}>
                        <Checkbox checked={isChecked} size="small" sx={{ color: "#075e54", "&.Mui-checked": { color: "#075e54" } }} />
                        <ListItemText
                          primary={prop.label}
                          secondary={prop.isActive === false ? "Hidden on homepage collage" : undefined}
                        />
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>

              {/* Quick Select Chips */}
              {availableProperties.length > 0 && (
                <Box sx={{ mt: 2 }}>
                  <Typography variant="caption" sx={{ color: "#64748b", display: "block", mb: 0.75, fontWeight: 700 }}>
                    Quick Select (click to toggle):
                  </Typography>
                  <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.75 }}>
                    {availableProperties.map((prop) => {
                      const isSelected = selectedPropertyIds.includes(prop.id);
                      return (
                        <Chip
                          key={prop.id}
                          label={prop.label}
                          onClick={() => handleTogglePropertyChip(prop.id)}
                          color={isSelected ? "primary" : "default"}
                          variant={isSelected ? "filled" : "outlined"}
                          size="small"
                          sx={{
                            cursor: "pointer",
                            fontWeight: isSelected ? 700 : 500,
                            ...(isSelected
                              ? { bgcolor: "#075e54", color: "#ffffff" }
                              : { bgcolor: "#f8fafc", borderColor: "#cbd5e1" }),
                          }}
                        />
                      );
                    })}
                  </Box>
                </Box>
              )}
            </Paper>

            <Paper elevation={0} sx={{ p: { xs: 1.75, sm: 2.5 }, border: "1px solid #e2e8f0", borderRadius: 3 }}>
              <Typography variant="subtitle2" sx={{ fontWeight: 800, color: "#334155", mb: 2 }}>
                Product Identity
              </Typography>
              <Stack spacing={2}>
                <TextField
                  fullWidth
                  size="small"
                  label="Product Title *"
                  placeholder="e.g., Pure Cold-Pressed Virgin Coconut Oil"
                  value={productContext.state.title || ""}
                  onChange={(e) => handleFormData({ title: e.target.value })}
                  helperText={`${(productContext.state.title || "").length}/200 characters (minimum 5)`}
                  error={(productContext.state.title || "").length > 0 && (productContext.state.title || "").length < 5}
                />

                <TextField
                  fullWidth
                  size="small"
                  label="Product SKU / ID"
                  placeholder="Leave blank to auto-generate unique SKU"
                  value={productContext.state.id || ""}
                  onChange={(e) => handleFormData({ id: e.target.value })}
                  disabled={action !== "ADD"}
                  helperText={
                    action === "ADD"
                      ? "Custom identifier or marketplace SKU. Leave empty to generate automatically."
                      : "Product SKU cannot be changed once created."
                  }
                />

                <TextField
                  fullWidth
                  size="small"
                  label="Search Keywords & Meta Tags"
                  placeholder="organic, cold pressed, keto, natural, vegan"
                  value={productContext.state.searchTerms || ""}
                  onChange={(e) => handleFormData({ searchTerms: e.target.value })}
                  helperText="Comma-separated keywords to help customers find this product"
                />
              </Stack>
            </Paper>
          </Stack>
        )}

        {/* TAB 1: Pricing & Inventory */}
        {activeTab === 1 && (
          <Stack spacing={2.5}>
            <Paper elevation={0} sx={{ p: { xs: 1.75, sm: 2.5 }, border: "1px solid #e2e8f0", borderRadius: 3 }}>
              <Typography variant="subtitle2" sx={{ fontWeight: 800, color: "#334155", mb: 2 }}>
                Pricing & Margins
              </Typography>

              <Stack direction={{ xs: "column", sm: "row" }} spacing={2} sx={{ mb: 2 }}>
                <TextField
                  fullWidth
                  size="small"
                  type="number"
                  label="MRP (Maximum Retail Price) *"
                  value={productContext.state.maxPrice || ""}
                  onChange={(e) => handleFormData({ maxPrice: Number(e.target.value) })}
                  InputProps={{
                    startAdornment: <InputAdornment position="start">₹</InputAdornment>,
                  }}
                  helperText="Official printed retail price"
                />

                <TextField
                  fullWidth
                  size="small"
                  type="number"
                  label="List Price (Selling Price) *"
                  value={productContext.state.listPrice || ""}
                  onChange={(e) => handleFormData({ listPrice: Number(e.target.value) })}
                  InputProps={{
                    startAdornment: <InputAdornment position="start">₹</InputAdornment>,
                  }}
                  helperText="Actual price charged to customer"
                  error={listPrice > mrp && mrp > 0}
                />
              </Stack>

              {/* Live Margin & Discount Insight Banner */}
              {mrp > 0 && listPrice > 0 && (
                <Box
                  sx={{
                    p: 1.5,
                    borderRadius: 2,
                    bgcolor: listPrice <= mrp ? "#f0fdf4" : "#fef2f2",
                    border: `1px solid ${listPrice <= mrp ? "#bbf7d0" : "#fecaca"}`,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    flexWrap: "wrap",
                    gap: 1,
                  }}
                >
                  <Typography variant="body2" sx={{ fontWeight: 600, color: listPrice <= mrp ? "#166534" : "#991b1b" }}>
                    {listPrice <= mrp
                      ? `Customer savings: ₹${discountAmount.toLocaleString("en-IN")} (${discountPercent}% OFF)`
                      : "Warning: List Price cannot be greater than MRP"}
                  </Typography>
                  {listPrice <= mrp && discountPercent > 0 && (
                    <Chip
                      label={`${discountPercent}% DISCOUNT`}
                      size="small"
                      sx={{ fontWeight: 800, bgcolor: "#15803d", color: "#ffffff" }}
                    />
                  )}
                </Box>
              )}
            </Paper>

            <Paper elevation={0} sx={{ p: { xs: 1.75, sm: 2.5 }, border: "1px solid #e2e8f0", borderRadius: 3 }}>
              <Typography variant="subtitle2" sx={{ fontWeight: 800, color: "#334155", mb: 2 }}>
                Inventory & Quantity Specifications
              </Typography>

              <Stack direction={{ xs: "column", sm: "row" }} spacing={2} sx={{ mb: 2 }}>
                <TextField
                  fullWidth
                  size="small"
                  type="number"
                  label="Units in Stock *"
                  value={productContext.state.unitsInStock ?? ""}
                  onChange={(e) => handleFormData({ unitsInStock: Number(e.target.value) })}
                  helperText="Current available inventory"
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <Chip
                          size="small"
                          label={
                            Number(productContext.state.unitsInStock) === 0
                              ? "Out of Stock"
                              : Number(productContext.state.unitsInStock) <= 5
                              ? "Low Stock"
                              : "In Stock"
                          }
                          color={
                            Number(productContext.state.unitsInStock) === 0
                              ? "error"
                              : Number(productContext.state.unitsInStock) <= 5
                              ? "warning"
                              : "success"
                          }
                          sx={{ height: 20, fontSize: "0.7rem", fontWeight: 700 }}
                        />
                      </InputAdornment>
                    ),
                  }}
                />

                <TextField
                  fullWidth
                  size="small"
                  type="number"
                  label="Net Quantity *"
                  placeholder="e.g., 500"
                  value={productContext.state.netQuantity || ""}
                  onChange={(e) => handleFormData({ netQuantity: Number(e.target.value) })}
                  helperText="Numeric amount in package"
                />

                <FormControl fullWidth size="small">
                  <InputLabel id="unit-type-select-label">Unit Type *</InputLabel>
                  <Select
                    labelId="unit-type-select-label"
                    value={productContext.state.unitType || ""}
                    label="Unit Type *"
                    onChange={(e) => handleFormData({ unitType: e.target.value })}
                  >
                    <MenuItem value="">
                      <em>None</em>
                    </MenuItem>
                    <MenuItem value="Grams">Grams (g)</MenuItem>
                    <MenuItem value="Kilograms">Kilograms (kg)</MenuItem>
                    <MenuItem value="Litres">Litres (L)</MenuItem>
                    <MenuItem value="Milliliters">Milliliters (ml)</MenuItem>
                    <MenuItem value="Piece">Piece (pc)</MenuItem>
                    <MenuItem value="Pack">Pack</MenuItem>
                    <MenuItem value="Set">Set</MenuItem>
                  </Select>
                </FormControl>
              </Stack>
            </Paper>
          </Stack>
        )}

        {/* TAB 2: Media & Visuals */}
        {activeTab === 2 && (
          <Stack spacing={2.5}>
            <Paper elevation={0} sx={{ p: { xs: 1.75, sm: 2.5 }, border: "1px solid #e2e8f0", borderRadius: 3 }}>
              <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ mb: 1.5 }}>
                <Box>
                  <Typography variant="subtitle2" sx={{ fontWeight: 800, color: "#334155" }}>
                    Product Images ({(productContext.state.images || []).length})
                  </Typography>
                  <Typography variant="caption" sx={{ color: "#64748b" }}>
                    The first image will be used as the primary storefront thumbnail.
                  </Typography>
                </Box>
                {isUploading && (
                  <Stack direction="row" spacing={1} alignItems="center">
                    <CircularProgress size={16} />
                    <Typography variant="caption" sx={{ color: "primary.main", fontWeight: 700 }}>
                      Uploading ({progress}%)
                    </Typography>
                  </Stack>
                )}
              </Stack>

              <Box sx={{ display: "flex", flexWrap: "wrap", alignItems: "center", gap: 1 }}>
                {(productContext.state.images || []).map((img, index) => {
                  const bgImg =
                    img.url !== undefined
                      ? `url(${img.url})`
                      : `url(${img.prefix}${img.data})`;

                  return (
                    <Box
                      className="uploaded-product"
                      key={img.name || index}
                      sx={{
                        backgroundImage: bgImg,
                        backgroundSize: "cover",
                        backgroundPosition: "center",
                      }}
                    >
                      {index === 0 && <Box className="primary-badge">Primary</Box>}
                      <Tooltip title="Delete photo">
                        <IconButton
                          className="delete-action-btn"
                          size="small"
                          onClick={() => {
                            if (window.confirm("Remove this image?")) {
                              handleDeleteFile(index, img.name);
                            }
                          }}
                        >
                          <DeleteIcon fontSize="small" />
                        </IconButton>
                      </Tooltip>
                    </Box>
                  );
                })}

                <FileUpload
                  acceptFileType="image/*"
                  handleChange={handleImageChange}
                  bgImageSrc={AddProductImage}
                  upProgress={progress}
                />
              </Box>
            </Paper>

            <Paper elevation={0} sx={{ p: { xs: 1.75, sm: 2.5 }, border: "1px solid #e2e8f0", borderRadius: 3 }}>
              <Typography variant="subtitle2" sx={{ fontWeight: 800, color: "#334155", mb: 0.5 }}>
                Product Video (Optional)
              </Typography>
              <Typography variant="caption" sx={{ color: "#64748b", display: "block", mb: 2 }}>
                Upload short showcase video (Max 20MB, MP4/WebM).
              </Typography>

              {videoData ? (
                <Box
                  className="uploaded-product"
                  sx={{
                    width: 220,
                    height: 140,
                    position: "relative",
                  }}
                >
                  <video
                    src={videoData.url}
                    muted
                    loop
                    autoPlay
                    playsInline
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                      borderRadius: 12,
                    }}
                  />
                  <Stack direction="row" spacing={0.5} sx={{ position: "absolute", top: 8, right: 8 }}>
                    <Tooltip title="Preview Video">
                      <IconButton
                        size="small"
                        sx={{ bgcolor: "rgba(255,255,255,0.9)", "&:hover": { bgcolor: "#ffffff" } }}
                        onClick={() => setOpenVideoDialog(true)}
                      >
                        <PlayCircleOutlineIcon fontSize="small" />
                      </IconButton>
                    </Tooltip>
                    <Tooltip title="Delete Video">
                      <IconButton
                        size="small"
                        sx={{ bgcolor: "rgba(255,255,255,0.9)", color: "#ef4444", "&:hover": { bgcolor: "#fee2e2" } }}
                        onClick={() => {
                          if (window.confirm("Delete product video?")) {
                            handleDeleteVideo(videoData.name);
                          }
                        }}
                      >
                        <DeleteIcon fontSize="small" />
                      </IconButton>
                    </Tooltip>
                  </Stack>
                </Box>
              ) : (
                <FileUpload
                  acceptFileType="video/*"
                  handleChange={handleVideoChange}
                  bgImageSrc={AddProductImage}
                  upProgress={videoProgress}
                  className="video-upload"
                />
              )}
            </Paper>
          </Stack>
        )}

        {/* TAB 3: Marketplaces */}
        {activeTab === 3 && (
          <Paper elevation={0} sx={{ p: { xs: 1.75, sm: 2.5 }, border: "1px solid #e2e8f0", borderRadius: 3 }}>
            <Typography variant="subtitle2" sx={{ fontWeight: 800, color: "#334155", mb: 0.5 }}>
              Marketplace Direct Links
            </Typography>
            <Typography variant="caption" sx={{ color: "#64748b", display: "block", mb: 2.5 }}>
              Provide URLs if this product is listed on major e-commerce platforms. These appear on the customer storefront.
            </Typography>

            <Stack spacing={2.5}>
              <TextField
                fullWidth
                size="small"
                label="Amazon Product URL"
                placeholder="https://www.amazon.in/dp/..."
                value={productContext.state.amazonURL || ""}
                onChange={(e) => handleFormData({ amazonURL: e.target.value })}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Chip label="Amazon" size="small" sx={{ fontWeight: 700, bgcolor: "#ff9900", color: "#000000" }} />
                    </InputAdornment>
                  ),
                }}
              />

              <TextField
                fullWidth
                size="small"
                label="Flipkart Product URL"
                placeholder="https://www.flipkart.com/..."
                value={productContext.state.flipkartURL || ""}
                onChange={(e) => handleFormData({ flipkartURL: e.target.value })}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Chip label="Flipkart" size="small" sx={{ fontWeight: 700, bgcolor: "#2874f0", color: "#ffffff" }} />
                    </InputAdornment>
                  ),
                }}
              />

              <TextField
                fullWidth
                size="small"
                label="Tata 1mg Product URL"
                placeholder="https://www.1mg.com/otc/..."
                value={productContext.state.tata1mgURL || ""}
                onChange={(e) => handleFormData({ tata1mgURL: e.target.value })}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Chip label="Tata 1mg" size="small" sx={{ fontWeight: 700, bgcolor: "#ff6f61", color: "#ffffff" }} />
                    </InputAdornment>
                  ),
                }}
              />
            </Stack>
          </Paper>
        )}

        {/* TAB 4: Description & Reviews */}
        {activeTab === 4 && (
          <Stack spacing={2.5}>
            <Paper elevation={0} sx={{ p: { xs: 1.75, sm: 2.5 }, border: "1px solid #e2e8f0", borderRadius: 3 }}>
              <Typography variant="subtitle2" sx={{ fontWeight: 800, color: "#334155", mb: 0.5 }}>
                Product Description *
              </Typography>
              <Typography variant="caption" sx={{ color: "#64748b", display: "block", mb: 1.5 }}>
                Rich description including ingredients, health benefits, usage directions, and storage tips.
              </Typography>

              <CKEditor
                editor={ClassicEditor}
                data={productContext.state.description || ""}
                onChange={(event, editor) => {
                  const data = editor.getData();
                  handleFormData({ description: data });
                }}
              />
            </Paper>

            {action === "EDIT" && (
              <Paper elevation={0} sx={{ p: { xs: 1.75, sm: 2.5 }, border: "1px solid #e2e8f0", borderRadius: 3 }}>
                <Stack direction="row" justifyContent="space-between" alignItems="center">
                  <Box>
                    <Typography variant="subtitle2" sx={{ fontWeight: 800, color: "#334155" }}>
                      Simulate Customer Ratings
                    </Typography>
                    <Typography variant="caption" sx={{ color: "#64748b" }}>
                      Populates authentic star rating distributions (predominantly 4 and 5 stars).
                    </Typography>
                  </Box>
                  <Button
                    variant="outlined"
                    color="warning"
                    size="small"
                    startIcon={<AutoAwesomeIcon />}
                    onClick={addRatings}
                    disabled={isAddingRatings}
                    sx={{ fontWeight: 700 }}
                  >
                    {isAddingRatings ? "Generating..." : "Generate Ratings"}
                  </Button>
                </Stack>
              </Paper>
            )}
          </Stack>
        )}
      </Box>

      {/* Sticky Action Footer */}
      <Box className="modal-footer">
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          sx={{ width: "100%", gap: { xs: 1, sm: 1.5 } }}
        >
          {/* Step navigation & danger action */}
          <Stack direction="row" spacing={{ xs: 0.75, sm: 1 }} alignItems="center">
            {activeTab > 0 && (
              <Button
                size="small"
                onClick={() => setActiveTab(activeTab - 1)}
                sx={{ color: "#64748b", fontWeight: 700, minWidth: 0, px: { xs: 1.25, sm: 2 } }}
              >
                Back
              </Button>
            )}
            {activeTab < 4 && (
              <Button
                size="small"
                variant="outlined"
                onClick={() => setActiveTab(activeTab + 1)}
                sx={{ fontWeight: 700, minWidth: 0, px: { xs: 1.25, sm: 2 } }}
              >
                Next
              </Button>
            )}
            {action === "EDIT" && onDeleteProduct && (
              <Tooltip title="Delete Product">
                <IconButton
                  color="error"
                  size="small"
                  onClick={() => {
                    if (window.confirm("Are you sure you want to permanently delete this product?")) {
                      onDeleteProduct(productContext.state);
                      hideModal();
                    }
                  }}
                  sx={{
                    bgcolor: "#fef2f2",
                    display: { xs: "inline-flex", sm: "none" },
                    "&:hover": { bgcolor: "#fee2e2" },
                  }}
                >
                  <DeleteIcon fontSize="small" />
                </IconButton>
              </Tooltip>
            )}
          </Stack>

          {/* Action buttons */}
          <Stack direction="row" spacing={{ xs: 1, sm: 1.5 }} alignItems="center">
            {action === "EDIT" && onDeleteProduct && (
              <Button
                color="error"
                size="small"
                startIcon={<DeleteIcon fontSize="small" />}
                onClick={() => {
                  if (window.confirm("Are you sure you want to permanently delete this product?")) {
                    onDeleteProduct(productContext.state);
                    hideModal();
                  }
                }}
                sx={{
                  fontWeight: 700,
                  display: { xs: "none", sm: "inline-flex" },
                }}
              >
                Delete Product
              </Button>
            )}

            <Button
              variant="text"
              size="small"
              onClick={hideModal}
              sx={{ fontWeight: 700, color: "#64748b", minWidth: 0, px: { xs: 1, sm: 2 } }}
            >
              Cancel
            </Button>

            <CustomButton
              variant="contained"
              color="primary"
              size="small"
              onClick={handleAddProductClick}
              disabled={isUploading || (productContext.state.title || "").length < 5}
              sx={{
                fontWeight: 700,
                px: { xs: 2, sm: 3 },
                py: { xs: 0.8, sm: 1 },
                borderRadius: "8px",
                minWidth: 0,
              }}
            >
              {isUploading ? (
                <Stack direction="row" spacing={0.75} alignItems="center">
                  <CircularProgress size={14} color="inherit" />
                  <span>Uploading...</span>
                </Stack>
              ) : action === "ADD" ? (
                "Publish"
              ) : (
                "Save"
              )}
            </CustomButton>
          </Stack>
        </Stack>
      </Box>

      {/* Video Dialog */}
      <Dialog
        open={openVideoDialog}
        onClose={() => setOpenVideoDialog(false)}
        fullWidth
        maxWidth="md"
        TransitionComponent={Transition}
      >
        <DialogTitle sx={{ fontWeight: 800 }}>Product Video Preview</DialogTitle>
        <DialogContent sx={{ p: 0, bgcolor: "#000000", display: "flex", justifyContent: "center" }}>
          {videoData && videoData.url && (
            <video
              src={videoData.url}
              controls
              style={{
                width: "100%",
                maxHeight: "75vh",
                objectFit: "contain",
              }}
            />
          )}
        </DialogContent>
        <DialogActions sx={{ p: 2 }}>
          <Button onClick={() => setOpenVideoDialog(false)} sx={{ fontWeight: 700 }}>
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default AddProduct;
